// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorUsage {
  Up = 0,
  Down = 1,
  FaultStopped = 2,
  Stopped = 3,
  Disconnected = 4
}
